module.exports = __webpack_public_path__ + "img/card_delete.dcc567f2.svg";